<template>
  <ReviewerHistory
    :histories="histories"
    :showPM="false"
  />
</template>
<script>
import { useCurrentGreenFitout } from '@/modules/tenantProjects/greenFitOut/hook'
import ReviewerHistory from '@/modules/tenantProjects/ReviewerHistory'
import { computed, unref } from 'vue-demi'
import { GREEN_FITOUT_HISTORY_ACTION_TYPE } from './consts'

export default {
  components: {
    ReviewerHistory,
  },
  setup () {
    // @TODO The currentSubmission variable should support be receive a value via param
    const currentSubmission = useCurrentGreenFitout()

    return {
      histories: computed(() => {
        const allowedActionTypes = [GREEN_FITOUT_HISTORY_ACTION_TYPE.NEXT_REVIEWER, GREEN_FITOUT_HISTORY_ACTION_TYPE.SEND]
        return (unref(currentSubmission).histories || []).filter(item => allowedActionTypes.includes(item.actionType))
      }),
    }
  },
}
</script>
